/**
 * MSW (Mock Service Worker) Plugin for Veloair
 *
 * This plugin initializes MSW to mock API endpoints.
 * It only runs in the browser (client-side) and when ENABLE_MSW is set to 'true'.
 * This allows MSW to work both in local dev and deployed dev/sandbox environments.
 */

import { setupMSW } from '@cvo/domain';
import { createSelectedOverrides } from '~~/msw-overrides';

export default defineNuxtPlugin({
  name: 'msw',
  parallel: false,
  async setup() {
    const config = useRuntimeConfig();

    // Only run when MSW is explicitly enabled via environment variable
    if (!config.public.msw.enabled) {
      return;
    }

    const baseUrl = config.public.bffGatewayBaseUrl as string;

    if (!baseUrl) {
      console.warn('[MSW Plugin] BFF Gateway base URL not configured');
      return;
    }

    try {
      const overrideHandlers = createSelectedOverrides(baseUrl, config.public.msw.overrides);

      // Initialize MSW with imported configuration
      await setupMSW({
        baseUrl,
        config: { endpoints: config.public.msw.endpoints },
        overrideHandlers,
        quiet: false,
      });
    } catch (error) {
      console.error('[MSW Plugin] Failed to initialize MSW:', error);
    }
  },
});
